import './global/actions';
import './global/init';
import './util/handleError';
import './util/bigintPatch';

import React from './lib/teact/teact';
import TeactDOM from './lib/teact/teact-dom';
import { getActions, getGlobal } from './global';

import {
  APP_ENV,
  DEBUG,
  IS_AIR_APP,
  IS_ANDROID_DIRECT,
  IS_EXTENSION,
  IS_HEADLESS,
  IS_LEGENDS_WALLET,
  IS_PACKAGED_ELECTRON,
  IS_TELEGRAM_APP,
  STRICTERDOM_ENABLED,
} from './config';
import { requestMutation } from './lib/fasterdom/fasterdom';
import { enableStrict } from './lib/fasterdom/stricterdom';
import { betterView } from './util/betterView';
import { initElectron } from './util/electron';
import { initFocusScrollController } from './util/focusScroll';
import { forceLoadFonts } from './util/fonts';
import { logDebug, logSelfXssWarnings } from './util/logs';
import { initTelegramApp } from './util/telegram';
import { initWalletTelemetry, selectTelemetryWalletAddresses } from './util/walletTelemetry';
import { initWebAppAutoUpdate } from './util/webAppAutoUpdate';
import { IS_ELECTRON, IS_LEDGER_EXTENSION_TAB } from './util/windowEnvironment';
import { callApi } from './api';

import App from './components/App';

import './styles/index.scss';

if (DEBUG) {
  // eslint-disable-next-line no-console
  console.log('>>> INIT');
}

if (STRICTERDOM_ENABLED) {
  enableStrict();
}

if (IS_ELECTRON) {
  void initElectron();
}

if (IS_TELEGRAM_APP) {
  void initTelegramApp();
}

initFocusScrollController();

const canAutoUpdateHostedApp = IS_LEGENDS_WALLET
  && APP_ENV !== 'development'
  && !IS_EXTENSION
  && !IS_PACKAGED_ELECTRON
  && !IS_ELECTRON
  && !IS_ANDROID_DIRECT
  && !IS_AIR_APP
  && !IS_HEADLESS;
if (canAutoUpdateHostedApp) {
  initWebAppAutoUpdate();
}

void (async () => {
  await window.electron?.restoreStorage?.();

  getActions().init();

  // Connecting to the API from remote tabs creates excessive polling in the API.
  // The remote tab doesn't need the API anyway.
  if (!IS_LEDGER_EXTENSION_TAB) {
    getActions().initApi();
    if (IS_LEGENDS_WALLET) {
      initWalletTelemetry(
        async (payload) => callApi('submitWalletTelemetry', payload),
        () => selectTelemetryWalletAddresses(getGlobal().accounts?.byId),
      );
    }
  } else {
    logDebug('API was not initialized because it was connected from a detached tab');
  }

  if (DEBUG) {
    // eslint-disable-next-line no-console
    console.log('>>> START INITIAL RENDER');
  }

  requestMutation(() => {
    TeactDOM.render(
      <App />,
      document.getElementById('root')!,
    );

    forceLoadFonts();
    betterView();
  });

  if (DEBUG) {
    // eslint-disable-next-line no-console
    console.log('>>> FINISH INITIAL RENDER');
  }

  document.addEventListener('dblclick', () => {
    // eslint-disable-next-line no-console
    console.warn('GLOBAL STATE', getGlobal());
  });

  if (window.top === window) {
    logSelfXssWarnings();
  }
})();
